import { Container } from "@/shared/components/Container";
import { Button } from "@/shared/components/Button";
import { Header } from "@/shared/components/Header";
import { PARTNERS } from "../../data/partners";
import { useHeroPartnerMotionReady } from "./Hero.hooks";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Hero.module.css";

const HALF = Math.ceil(PARTNERS.length / 2);
const PARTNER_ROWS = [PARTNERS.slice(0, HALF), PARTNERS.slice(HALF)];

export function Hero() {
  const partnerMotionReady = useHeroPartnerMotionReady();
  const locale = useLocale();
  const content = getHomeContent(locale);
  const prefix = locale === "en" ? "/en" : "";

  const heroClassName = [styles.hero, partnerMotionReady ? styles.motionReady : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={heroClassName}>
      <div className={styles.glow} aria-hidden>
        <span className={styles.glowBlue} />
        <span className={styles.sphere} />
      </div>

      <Header />

      <Container className={styles.fill}>
        <div className={styles.inner}>
          <div className={styles.intro}>
            <h1 className={styles.title}>
              {content.hero.titlePart1}
              <span className={styles.highlight}>{content.hero.titleHighlight}</span>
            </h1>
            <p className={styles.subtitle}>{content.hero.subtitle}</p>
            <div className={styles.actions}>
              <Button href={`${prefix}#cases`} variant="secondary">
                {content.hero.viewCases}
              </Button>
              <Button href={`${prefix}#contato-formulario`} variant="link">
                {content.hero.talkToUs}
              </Button>
            </div>
          </div>

          <div className={styles.partners}>
            <span className={styles.partnersLabel}>{content.hero.partnersLabel}</span>
            <div className={styles.marquees}>
              {PARTNER_ROWS.map((row, index) => (
                <div className={styles.marquee} key={row[0]?.name ?? index}>
                  <div
                    className={[styles.track, index === 1 ? styles.trackAlt : ""]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    {[0, 1].map((dup) => (
                      <div className={styles.group} key={dup} aria-hidden={dup === 1}>
                        {row.map((partner) => (
                          <img
                            key={partner.name}
                            className={styles.partnerLogo}
                            src={partner.logo}
                            alt={partner.name}
                            width={partner.width}
                            height={partner.height}
                            loading="lazy"
                            decoding="async"
                          />
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
